module.exports = __webpack_public_path__ + "img/mpp_banner1.ebff7591.png";